import { motion } from "framer-motion";
import { WHY_CHOOSE } from "@/lib/site-data";
import { Check } from "lucide-react";

const IMG = "https://images.pexels.com/photos/30836332/pexels-photo-30836332.jpeg";

export default function WhyChoose() {
  return (
    <section data-testid="why-section" id="why" className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 grid lg:grid-cols-12 gap-12 items-center">
        <motion.div
          initial={{ opacity: 0, x: -24 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="lg:col-span-5"
        >
          <div className="relative rounded-2xl overflow-hidden border border-[#E5E5E5]">
            <img src={IMG} alt="Refinery crucible" className="w-full h-[480px] object-cover" />
            <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, transparent 50%, rgba(255,255,255,0.6))" }} />
          </div>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, x: 24 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="lg:col-span-7"
        >
          <div className="text-[11px] uppercase tracking-[0.22em] text-[#D4AF37] font-semibold">Why Agroya</div>
          <h2 className="font-heading mt-3 text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight">
            A refinery built around <span className="gold-gradient-text font-medium">your trust</span>.
          </h2>
          <ul className="mt-8 grid sm:grid-cols-2 gap-3">
            {WHY_CHOOSE.map((w, i) => (
              <motion.li
                key={w}
                initial={{ opacity: 0, y: 12 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.04 }}
                data-testid={`why-${i}`}
                className="flex items-center gap-3 p-3.5 border border-[#E5E5E5] rounded-md bg-[#F4F9FC]/40 hover:border-[#D4AF37] hover:bg-white transition-all"
              >
                <span className="w-7 h-7 rounded-full bg-white border border-[#E5E5E5] flex items-center justify-center shrink-0">
                  <Check className="w-3.5 h-3.5 text-[#D4AF37]" strokeWidth={2} />
                </span>
                <span className="text-sm text-[#0A0A0A] font-medium">{w}</span>
              </motion.li>
            ))}
          </ul>
        </motion.div>
      </div>
    </section>
  );
}
